import { Component } from 'san';
import helpService from 'src/services/help.service';

export default class ConnectAdmin extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        content: string;
    } {
        return {
            isShow: false,
            content: '',
        };
    }

    show() {
        this.data.set('isShow', true);
        this.getContent();
    }

    cancel() {
        this.data.set('isShow', false);
    }

    getContent() {
        helpService.getConnectAdmin(true).then((content) => {
            this.data.set('content', content);
        });
    }
}
